import { useQuery } from "@tanstack/react-query"
import { zendeskIntegrationQuery } from "modules/settings/lib/zendesk/zendeskIntegrationQuery"

export function useZendeskIntegrationQuery(...args: Parameters<typeof zendeskIntegrationQuery>) {
  return useQuery(zendeskIntegrationQuery(...args))
}
